/**
 * 账户服务组件
 */

import { useEffect, useState } from 'react';
import {
    Row,
    Col,
} from 'antd';
import $ from 'jquery';
import { AddRequestHeaders } from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

import OrgStructureGraph from '../seals/OrgStructureGraph.js';
import UserUTACD from '../seals/UserUTACD.js';
import UserUDATC from '../seals/UserUDATC.js';
import UserUDEBC from '../seals/UserUDEBC.js';

const Seal = (props) => {
    const [orgInfosLists, setOrgInfosLists] = useState([]);

    useEffect(() => {
        /**
        * 获取组织下拉列表
        */
        $.ajax({
            url: `${CNF.sealApi}orgs/infos?rss=list`,
            headers: AddRequestHeaders(),
            type: 'GET',
            dataType: 'JSON', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        setOrgInfosLists(data.dat);
                    }
                }
            }
        })
    }, []);

    return <>
        {
            props.btnLists && props.btnLists.indexOf('btn_seal_org_structure') >= 0 ? <div style={{
                margin: '10px 5px 0 0', padding: '10px 20px 20px 20px', background: '#fff',
                border: '1px solid #E8E8E8',
                borderRadius: '5px',
                boxShadow: '0 0 5px 2px #E8E8E8',
            }}>
                <OrgStructureGraph orgInfosLists={orgInfosLists} />
            </div> : ''
        }
        {
            props.btnLists && props.btnLists.indexOf('btn_seal_report_user_utacd') >= 0 ? <div style={{
                marginTop: '10px', padding: '10px 20px 20px 20px', background: '#fff',
                border: '1px solid #E8E8E8',
                borderRadius: '5px',
                boxShadow: '0 0 5px 2px #E8E8E8',
            }}><p>每日用户活跃统计</p>
                <UserUTACD />
            </div> : ''
        }
        <Row>
            {
                props.btnLists && props.btnLists.indexOf('btn_seal_report_user_udatc') >= 0 ? <Col span={12}>
                    <div style={{
                        margin: '10px 5px 0 0', padding: '10px 20px 20px 20px', background: '#fff',
                        border: '1px solid #E8E8E8',
                        borderRadius: '5px',
                        boxShadow: '0 0 5px 2px #E8E8E8',
                    }}><p>能力类型分类占比</p>
                        <UserUDATC orgInfosLists={orgInfosLists} />
                    </div>
                </Col> : ''
            }
            {
                props.btnLists && props.btnLists.indexOf('btn_seal_report_user_udebc') >= 0 ? <Col span={12}>
                    <div style={{
                        margin: '10px 0 0 5px', padding: '10px 20px 20px 20px', background: '#fff',
                        border: '1px solid #E8E8E8',
                        borderRadius: '5px',
                        boxShadow: '0 0 5px 2px #E8E8E8',
                    }}><p>学历类型分类占比</p>
                        <UserUDEBC orgInfosLists={orgInfosLists} />
                    </div>
                </Col> : ''
            }
        </Row>
    </>
}

export default Seal;